import { createSlice } from '@reduxjs/toolkit';
import { fetchQurbaniProducts, saveQurbaniStep, fetchQurbaniInformation, fetchQurbaniCart, emptyQurbaniCart } from '../thunk/qurbaniThunk';

const initialState = {
    products: [],
    productsLoading: false,
    productsError: null,
    saveStepLoading: false,
    saveStepError: null,
    information: null,
    informationLoading: false,
    informationError: null,
    cart: null,
    cartLoading: false,
    cartError: null,
};

const qurbaniSlice = createSlice({
    name: 'qurbani',
    initialState,
    reducers: {
        clearQurbaniCart: (state) => {
            state.cart = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchQurbaniProducts.pending, (state) => {
                state.productsLoading = true;
                state.productsError = null;
            })
            .addCase(fetchQurbaniProducts.fulfilled, (state, action) => {
                state.productsLoading = false;
                state.products = action.payload?.data || [];
            })
            .addCase(fetchQurbaniProducts.rejected, (state, action) => {
                state.productsLoading = false;
                state.productsError = action.payload;
            })
            .addCase(saveQurbaniStep.pending, (state) => {
                state.saveStepLoading = true;
                state.saveStepError = null;
            })
            .addCase(saveQurbaniStep.fulfilled, (state) => {
                state.saveStepLoading = false;
            })
            .addCase(saveQurbaniStep.rejected, (state, action) => {
                state.saveStepLoading = false;
                state.saveStepError = action.payload;
            })
            .addCase(fetchQurbaniInformation.pending, (state) => {
                state.informationLoading = true;
                state.informationError = null;
            })
            .addCase(fetchQurbaniInformation.fulfilled, (state, action) => {
                state.informationLoading = false;
                state.information = action.payload;
            })
            .addCase(fetchQurbaniInformation.rejected, (state, action) => {
                state.informationLoading = false;
                state.informationError = action.payload;
            })
            .addCase(fetchQurbaniCart.pending, (state) => {
                state.cartLoading = true;
                state.cartError = null;
            })
            .addCase(fetchQurbaniCart.fulfilled, (state, action) => {
                state.cartLoading = false;
                state.cart = action.payload;
            })
            .addCase(fetchQurbaniCart.rejected, (state, action) => {
                state.cartLoading = false;
                state.cartError = action.payload;
            })
            .addCase(emptyQurbaniCart.pending, (state) => {
                state.cartLoading = true;
                state.cartError = null;
            })
            .addCase(emptyQurbaniCart.fulfilled, (state, action) => {
                state.cartLoading = false;
                state.cart = action.payload;
            })
            .addCase(emptyQurbaniCart.rejected, (state, action) => {
                state.cartLoading = false;
                state.cartError = action.payload;
            });
    },
});

export const { clearQurbaniCart } = qurbaniSlice.actions;

export default qurbaniSlice.reducer;

// Selectors
export const selectCharities = (state) => state.qurbani.information?.data?.charity || [];
export const selectCharitiesLoading = (state) => state.qurbani.informationLoading;
export const selectCharitiesError = (state) => state.qurbani.informationError;

export const selectQurbaniProducts = (state) => state.qurbani.products;
export const selectQurbaniProductsLoading = (state) => state.qurbani.productsLoading;
export const selectQurbaniProductsError = (state) => state.qurbani.productsError;

export const selectQurbaniFarms = (state) => state.qurbani.information?.data?.farm || [];
export const selectQurbaniFarmsLoading = (state) => state.qurbani.informationLoading;

export const selectQurbaniInformation = (state) => state.qurbani.information;
export const selectQurbaniInformationLoading = (state) => state.qurbani.informationLoading;

export const selectQurbaniCart = (state) => state.qurbani.cart;
export const selectQurbaniCartLoading = (state) => state.qurbani.cartLoading;
